import { ReactNode } from 'react';
import styled from 'styled-components';

import { InputType } from '../../Types';
import ThemeColors from "../../config/themeColors";

interface Props {
    inputType: InputType,
    children?: ReactNode,
    label?: string,
    invalidfield?: boolean,
    fullwidth?: boolean,
    whitebg?: boolean,
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
    value?: string | number,
    type?: string,
    name?: string
}
const DefaultInput = styled.input<Props>`
    border: 1px solid ${ThemeColors.inputBorder};
    width: 100%;
    margin-bottom: 0.5rem;
    border-radius: 8px;
    background-color: #f8f9fa;
    transition: all 0.3s ease;
    padding: 13px;
    font-size: 1rem;
    display: block;
    background-clip: padding-box;
    color: ${ThemeColors.text};
    &:focus {
        outline: 0;
        background-color: ${ThemeColors.white};
        border-color: ${ThemeColors.ftgOrange};
        box-shadow: 0 0 0 1px ${ThemeColors.ftgOrangeHover};
    }
    ${props => props.invalidfield ? 
        'border: 1px solid ' + ThemeColors.danger + ';' +
        'box-shadow: 0 0 0 1px' + ThemeColors.dangerHover + ';' +
        'color: ' + ThemeColors.danger + ';'
    : null}; 
`;
const SearchInput = styled(DefaultInput)<Props>`
    border-radius: 8px;
    padding: 6px;
    margin-bottom: 0;
    background-color: ${ThemeColors.white};
    font-size: 0.9rem;
    padding-left: 13px;
    @media(min-width: 768px) {
        bottom: 0;
        position: absolute;
        right: 0;
        width: 20%;
        border-radius: .35rem;
    }
`;
const FilterInput = styled(DefaultInput)<Props>`
    padding: 6px;
    margin-bottom: 0;
    max-width: 160px;
    background-color: ${ThemeColors.white};
    max-width: ${props => props.fullwidth ? '100%' : '160px'};
    font-size: 0.9rem;
`;
const NumberNav = styled(DefaultInput)`
    width: 55px;
    padding: 6px;
    display: inline-block;
`;
const LessPadding = styled(DefaultInput)`
    padding: 6px;
`;
const Label = styled.label`
    margin-bottom: 0.2rem;
`;

const Input = (props: Props) => {

    let Input = <DefaultInput {...props}>{props.children}</DefaultInput>;

    switch(props.inputType) {
        case InputType.Filtered:
            Input = <FilterInput {...props}>{props.children}</FilterInput>
            break;
        case InputType.LessPadding:
            Input = <LessPadding {...props}>{props.children}</LessPadding>
            break;
        case InputType.NumberNav:
            Input = <NumberNav {...props}>{props.children}</NumberNav>
            break;     
        case InputType.SearchInput:
            Input = <SearchInput 
                onChange={props.onChange}
                value={props.value}
                name={props.name}
                type={props.type}
                autoComplete="off"
                placeholder="Zoeken..."
                {...props}>{props.children}</SearchInput>
            break;
    }
    return (
        <>
            {props.label ? <Label>{props.label}</Label> : null}
            {Input}
        </>
    );
}

export default Input;